var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h4',{staticStyle:{"margin-top":"20%"},domProps:{"textContent":_vm._s(_vm._trans(''))}},[_vm._v("ERROR! Missing Component:")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h1',{staticClass:"mt-4 center",staticStyle:{"color":"red","font-weight":"900"}},[_vm._v(_vm._s(_vm.params))]),_vm._v(" "),_c('hr')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42c2c466","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/_eng/globals/dzmissing.vue
// module id = 1642
// module chunks = 147